var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.timer_visible,
          expression: "timer_visible"
        }
      ],
      attrs: { id: "auto-update-panel" }
    },
    [
      _c("QpeTooltip", {
        attrs: { tooltip_position: "top" },
        scopedSlots: _vm._u([
          {
            key: "hovered_item",
            fn: function() {
              return [
                _c(
                  "v-icon",
                  {
                    attrs: {
                      color: _vm.is_activate_auto_update ? "#2cfde1" : "#b3b7c4"
                    },
                    on: { click: _vm.toggle_auto_update_icon }
                  },
                  [
                    _vm._v(
                      "\n                icon-autorenew-start\n            "
                    )
                  ]
                )
              ]
            },
            proxy: true
          },
          {
            key: "tooltip_content",
            fn: function() {
              return [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("__auto_update_panel.tooltip")))
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }